import ErrorMessage, { Title } from './ErrorMessage'
import Generic from './GenericError'

export default Object.assign(ErrorMessage, { Title, Generic })
